import React from 'react';
import { Icon } from '@benzinga/core-ui';
import { faLongArrowAltRight } from '@fortawesome/pro-solid-svg-icons/faLongArrowAltRight';
import styles from './CompactArticleView.module.scss';

export interface CompactArticleViewProps {
  title: string;
  url: string;
  subtitle: string;
  badge?: string;
}

export const CompactArticleView: React.FC<CompactArticleViewProps> = ({ badge, subtitle, title, url }) => {
  return (
    <article className={`${styles.card} compact-article-view-container`}>
      <a className={styles.link} href={url} rel="noopener noreferrer" target="_blank">
        {badge ? (
          <span aria-hidden="true" className={styles.badge}>
            {badge}
          </span>
        ) : null}
        <h3 className={styles.title}>{title}</h3>
        {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
        <span className={styles.action}>
          Read more
          <Icon className={styles.actionIcon} icon={faLongArrowAltRight} />
        </span>
      </a>
    </article>
  );
};
